<template>
    <div class="h-screen w-screen block dark:text-main-text-dark bg-gray-50 dark:bg-gray-500 overflow-auto">
        <NuxtPage />
    </div>
</template>

<script lang="ts" setup>
import { checkRoutePermission } from '@/utils/permission-check'

const config = useRuntimeConfig().public
useHead({
  title: config.appName
})
const route = useRoute()
const initialized = ref(false)
const { colors } = useRuntimeConfig().public
const store = $store()
const themeColor = store.theme.getColor

const getSystemConfig = async () => {
  try {
    const result = await $api($url.system.getSystemConfig)
    const data: any = $lodash.get(result, 'data.value')
    if (data.success) {
      store.system.setCompany(data.data.company)
      store.system.setWorkspaceCompany(data.data?.workspaceCompany)
      store.system.setWorkspace(data.data.workspace)
      store.system.setWorkspaceUsers(data.data.workspaceUsers)
      store.system.setCompanyUsers(data.data.companyUsers)
      store.system.setPrimaryColor(data.data.primaryColor)
      store.system.setGroup(data.data.group)
      useState('group', () => data.data.group)
      store.userConfig.setUser(data.data.user)
    }
  } catch (_e) {}
}
const getGlobalSettings = async () => {
  const api = $url.settings.getGlobalSettings
  const result = await $api(api)

  const data: any = $lodash.get(result, 'data.value')
  if (data.success) {
    store.globalSettings.setGlobalSettings(data.data)
  } else {
    return true
  }
}

const setThemeColor = () => {
  if (process.client && colors[themeColor as keyof typeof colors]) {
    const color = colors[themeColor as keyof typeof colors]
    const r: HTMLElement | null = document.querySelector(':root')
    if (r) {
      r.style.setProperty('--primary-main-50', color['50'])
      r.style.setProperty('--primary-main-100', color['100'])
      r.style.setProperty('--primary-main-200', color['200'])
      r.style.setProperty('--primary-main-300', color['300'])
      r.style.setProperty('--primary-main-400', color['400'])
      r.style.setProperty('--primary-main-500', color['500'])
      r.style.setProperty('--primary-main-600', color['600'])
      r.style.setProperty('--primary-main-700', color['700'])
      r.style.setProperty('--primary-main-800', color['800'])
      r.style.setProperty('--primary-main-900', color['900'])
    }
  }
}

onMounted(async () => {
  themeColor !== 'orange' && setThemeColor()
  await getSystemConfig()
  const user: any = $store().userConfig.user
  useState('initialized', () => true)
  themeColor !== 'orange' && setThemeColor()
  nextTick(() => {
    initialized.value = true
  })
  if (process.client) {
    const { $io } = useNuxtApp()
    $io.listen('company-user-notification-' + user._id, (data: any) => {
      // Notification data debug
    })
  }
  await getGlobalSettings()

  checkRoutePermission((route.value?.name || '').toString(), true)
})
</script>
